import LoadingBtn from '@Components/Common/LoadingBtn';
import NavBack from '@Components/Common/NavBack';
import CSpinner from '@Components/CSpinner';
import {
  Shell,
  ShellHeader,
  ShellFooter,
  ShellContent,
} from '@Components/Shell';
import {
  Button,
  Divider,
  Flex,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { GmailInlinePolicyModal } from './Components/GmailInlinePolicyModal';
import { PolicyTabs } from './Components/PolicyTabs';
import { PolicyTypeEnum } from './utils/constants';
import { TabsEnum } from './utils/types';

export const PolicyShell = (props: {
  tabs: TabsEnum[];
  tabPanels: any[];
  tabStatusArr: any[];
  activeTabIndex: number;
  isLoading: boolean;
  saveDisabled: boolean;
  goBack: () => void;
  handleSubmitPolicy: () => Promise<void>;
  setActiveTabIndex: (index: number) => void;
  policyType: PolicyTypeEnum;
}) => {
  const {
    tabs,
    tabPanels,
    tabStatusArr,
    activeTabIndex,
    isLoading,
    saveDisabled,
    goBack,
    handleSubmitPolicy,
    setActiveTabIndex,
    policyType,
  } = props;
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <>
      <Shell>
        <ShellHeader>
          <NavBack fixed={false} onBack={goBack} p="10px 0px" flexShrink={0} />
          <Divider />
        </ShellHeader>
        <ShellContent>
          {isLoading && <CSpinner />}
          <PolicyTabs
            allTabs={tabs}
            allTabPanelComponents={tabPanels}
            tabStatusArr={tabStatusArr}
            onTabClick={setActiveTabIndex}
            activeTabIndex={activeTabIndex}
          />
        </ShellContent>
        <ShellFooter>
          <Flex
            height={64}
            pl="4x"
            alignItems="center"
            background={colorStyle.background.secondary}
            flexShrink={0}
            gap="2x"
          >
            <LoadingBtn
              loading={isLoading}
              onClick={handleSubmitPolicy}
              variant="primary"
              disabled={saveDisabled}
            >
              {t('reportCommon.buttons.save')}
            </LoadingBtn>
            <Button onClick={goBack}>{t('reportCommon.buttons.cancel')}</Button>
          </Flex>
        </ShellFooter>
      </Shell>
      {(policyType === PolicyTypeEnum.GmailInline ||
        policyType === PolicyTypeEnum.ExchangeInline) && (
        <GmailInlinePolicyModal />
      )}
    </>
  );
};
